import { Flex, Spinner } from '@chakra-ui/react'
import React from 'react'

const SpinLoader = ({mt}) => {
  return (
    <Flex marginTop={mt || "20rem"} justifyContent={"center"}>
      <Spinner size={"lg"} color="#7F56D9" />
    </Flex>
  )
}

export default SpinLoader